<script setup>
import PartnerForm from '@frontJs/components/forms/projectManagement/apikom/PartnerForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { partner } = defineProps({
    partner: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="partner">
            Mettre à jour le partenaire #{{ partner.id }} - Partenaires - Apikom
            - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un partenaire - Partenaires - Apikom - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="partner">
        Gestion de projet - Apikom - Partenaires - Mettre à jour le partenaire
        #{{ partner.id }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Apikom - Partenaires - Créer un partenaire
    </PageTitle>

    <PartnerForm :partner="partner" />
</template>
